module.exports = __webpack_public_path__ + "static/media/emil.c2c1ef86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/employees/emil.jpg
// module id = 496
// module chunks = 0